<template>
  <div class="min-h-screen lg:flex lg:items-center lg:justify-center
              before:hidden lg:before:block before:content-[''] before:h-full before:w-1/2 before:fixed before:top-0 before:right-0 before:shadow-[15px_0_30px_0_rgba(0,0,0,.18)]"
       :class="rightSideBgColor"
  >
    <div class="pt-[4.75rem] lg:p-0 lg:relative lg:flex lg:justify-between lg:w-full lg:max-w-4xl">
      <!-- Left Side -->
      <div class="pt-0 p-4 max-w-sm mx-auto lg:p-0 lg:m-0 lg:w-full lg:pb-10">
        <header
            class="h-[3.75rem] bg-white fixed inset-x-0 top-0 p-4 lg:h-auto lg:bg-transparent lg:static lg:p-0 lg:z-auto"
            :class="detailsModalOpen ? 'z-[51]' : 'z-10 lg:z-auto'"
        >
          <div class="flex justify-between items-center max-w-sm m-auto">
            <RouterLink :to="{name: 'landing'}">
              <img class="w-[5.875rem] lg:w-28" src="@/assets/logo.svg" alt="trguj.me logo">
            </RouterLink>
            <button
                v-if="!orderHasError"
                class="flex items-center text-gray-500 focus:outline-none lg:hidden"
                type="button"
                @click="handleDetailsModalOpen"
            >
              <span class="font-medium text-sm">
                {{ detailsModalOpen ? 'Zatvori' : 'Detalji' }}
              </span>
              <svg class="flex-shrink-0 ml-2 transition-transform"
                   :class="{'-rotate-180' : detailsModalOpen}"
                   width="16" height="16" viewBox="0 0 24 24" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </header>

        <div class="flex flex-col items-center text-center lg:mt-8 lg:text-left lg:items-start">
          <AppLoader v-if="fetchingOrder"></AppLoader>
          <template v-else>
            <template v-if="products.length">
              <div class="mb-8 mx-8 cursor-pointer lg:hidden"
                   @click="detailsModalOpen = true"
              >
                <div class="relative flex items-center justify-center h-[7.5rem]">
                  <img v-if="featuredProduct"
                       :src="featuredProduct.image"
                       :alt="featuredProduct.name"
                       class="max-w-full max-h-[7.5rem] rounded-md"
                  >
                  <div
                      class="absolute mx-auto -bottom-2.5 flex items-center w-fit min-w-[5.75rem] max-w-[8.4375rem] px-2 py-0.5 bg-white font-bold text-gray-900 shadow-md text-xs text-center rounded-lg">
                    <span class="flex-1">
                      {{ productsQtyLabel(products.length) }}
                    </span>
                    <svg class="-mr-1" width="13" height="13" viewBox="0 0 24 24" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="flex flex-col">
                <span class="font-medium text-gray-500">
                  Artikli
                </span>
              </div>
            </template>
            <div v-else>
              <p class="text-gray-700 text-lg">
                Nema proizvoda
              </p>
            </div>
          </template>
        </div>

        <section v-if="products.length"
                 class="hidden my-8 max-h-[50vh] overflow-y-auto pr-2 lg:block"
        >
          <OrderItems></OrderItems>
        </section>

        <div class="flex flex-col">
                <span class="font-medium text-gray-500">
                  Total
                </span>
          <span class="block mt-0.5 font-semibold text-3xl text-gray-800 tracking-tight lg:text-4xl">
                  {{ priceInEur(total) }}
                </span>
        </div>
      </div>

      <!-- Right Side -->
      <div class="mt-4 pt-1.5 p-4 lg:p-0 lg:mt-0 lg:max-w-sm lg:w-full lg:self-center">
        <div class="max-w-sm mx-auto">
          <div class="lg:h-[27rem]">
            <div class="lg:pb-8">
              <RouterView v-if="orderHasStatus"></RouterView>
              <CardForm v-else></CardForm>
            </div>
          </div>
        </div>
      </div>


      <!-- Footer -->
      <footer
          class="pt-4 pb-8 lg:flex-row lg:absolute lg:left-0 lg:bottom-0 lg:my-3 lg:p-0">
        <div class="flex flex-col items-center lg:flex-row lg:divide-x">
          <div class="py-1 lg:p-0 lg:pr-4">
            <a href="https://trguj.me/" target="_blank" class="flex items-center text-gray-400 text-xs">
              Platforma
              <svg class="ml-1" xmlns="http://www.w3.org/2000/svg" width="69" height="16" fill="none">
                <path
                    d="M35.964.346A1.54 1.54 0 0 1 36.942 0h.001a1.48 1.48 0 0 1 1.082.45 1.54 1.54 0 0 1 .191 1.946 1.54 1.54 0 0 1-1.872.565 1.54 1.54 0 0 1-.917-1.726 1.54 1.54 0 0 1 .536-.889zM1.363 2.195l2.558-.764v2.383h1.747v2.457H3.921v3.017c-.017.138.014.278.089.396s.187.207.319.251c.44.104.895.132 1.345.084v2.312c-1.624.171-2.748.015-3.373-.468s-.937-1.343-.937-2.581V6.271H-.002V3.814h1.365V2.195zm8.904 3.136V3.822H7.712v8.522h2.555V8.492a1.72 1.72 0 0 1 .811-1.627c.526-.311 1.146-.423 1.747-.317V3.646c-.561-.005-1.114.146-1.594.437a2.1 2.1 0 0 0-.964 1.249zm9.216-1.497c.433.192.814.484 1.113.851l-.004-.864h2.489v8.092c.077 1.166-.412 2.299-1.314 3.042-.912.7-2.037 1.064-3.186 1.031-1.921 0-3.268-.687-4.04-2.062l2.184-1.26c.348.546.91.927 1.547 1.036a2.35 2.35 0 0 0 1.811-.437 1.74 1.74 0 0 0 .513-1.355v-.784c-.606.746-1.53 1.164-2.49 1.109a3.95 3.95 0 0 1-2.991-1.271 4.5 4.5 0 0 1 0-6.115c.769-.834 1.857-1.297 2.991-1.271.473-.024.945.064 1.377.256zm-.949 6.052a2.29 2.29 0 0 0 1.483-.546 2.06 2.06 0 0 0 0-2.865 2.29 2.29 0 0 0-2.966 0c-.775.798-.775 2.068 0 2.865a2.29 2.29 0 0 0 1.483.546zm23.016-.546c-.378-.002-.745.127-1.038.367s-.493.573-.567.944-.02.754.157 1.088.464.595.813.74c.718.299 1.548.055 1.981-.597a1.63 1.63 0 0 0 .268-1.065c-.037-.376-.203-.726-.47-.993a1.55 1.55 0 0 0-1.143-.477l.001-.006zm12.862-5.762c-.473-.037-.948.047-1.381.244s-.807.5-1.09.881c-.242-.366-.575-.663-.966-.86a2.51 2.51 0 0 0-1.266-.265c-.436-.039-.875.035-1.275.214s-.747.457-1.009.809v-.779h-2.556v8.522h2.556V7.539c-.024-.421.099-.837.35-1.176.119-.143.27-.255.441-.329s.356-.107.542-.097c.17-.011.341.018.499.083s.299.165.412.293c.218.293.336.656.315 1.024v5.01h2.556V7.541c-.024-.421.099-.837.349-1.176.119-.142.27-.255.44-.329s.355-.107.54-.097c.171-.011.341.017.499.082s.299.165.413.293c.224.293.336.656.316 1.024v5.01h2.556V7.116a3.64 3.64 0 0 0-.886-2.566c-.601-.655-1.466-1.003-2.348-.966l-.006-.005zM68.55 8.077c.034-1.193-.409-2.35-1.234-3.213-.397-.419-.878-.75-1.411-.972a4.12 4.12 0 0 0-1.684-.315 4.55 4.55 0 0 0-4.178 2.787c-.346.823-.442 1.73-.277 2.608s.585 1.687 1.208 2.328c.456.434.996.771 1.587.99a4.66 4.66 0 0 0 1.848.287c.717.042 1.432-.096 2.082-.403s1.211-.771 1.634-1.351l-2.045-1.176a2.12 2.12 0 0 1-1.638.648c-1.068 0-1.75-.398-2.045-1.193h6.051a5.24 5.24 0 0 0 .109-1.024l-.005-.001zm-6.197-.886c.091-.413.331-.777.673-1.025s.763-.362 1.184-.32a1.7 1.7 0 0 1 1.807 1.345h-3.663zm-26.69-3.369h.001 2.555v8.521c0 1.332-.316 2.292-.948 2.881s-1.625.844-2.966.764v-2.457a1.45 1.45 0 0 0 1.037-.247c.119-.125.209-.274.265-.437s.076-.337.058-.508V6.373h-2.362v5.97h-2.556v-.8a2.83 2.83 0 0 1-2.437 1.037 3.04 3.04 0 0 1-2.275-.937c-.639-.706-.966-1.639-.912-2.589V3.82h2.555v4.859a1.52 1.52 0 0 0 .418 1.152 1.48 1.48 0 0 0 1.065.401c.213.011.427-.023.627-.1s.381-.194.533-.345a1.83 1.83 0 0 0 .426-1.31V3.822h4.916z"
                    fill="currentColor"/>
              </svg>
            </a>
          </div>
          <div class="space-x-1 lg:pl-4">
            <button class="p-1 text-gray-400 text-xs"
                    @click="onTrgujInfoModalOpen('legal')"
            >
              Uslovi
            </button>
            <button class="p-1 text-gray-400 text-xs"
                    @click="onTrgujInfoModalOpen('contact')"
            >
              Kontakt
            </button>
          </div>
        </div>
      </footer>


    </div>
  </div>

  <DetailsModal
      ref="detailsModal"
      v-if="detailsModalOpen"
      :trigger-show="detailsModalOpen"
      @close="detailsModalOpen = false"
      class="lg:hidden"
  ></DetailsModal>

  <TrgujInfoModal
      v-if="trgujInfoModal.open"
      :trigger-show="trgujInfoModal.open"
      @close="onTrgujInfoModalClose"
      :tab="trgujInfoModal.tab"
  ></TrgujInfoModal>

  <OrderErrorModal
      v-if="orderHasError"
      :trigger-show="orderHasError"
      :order-error="errors.get('order')"
  ></OrderErrorModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {FETCH_ORDER} from "@/store/types/actions.type";
import {priceInEur, productsQtyLabel} from "@/helpers/price";
import {useToast} from "vue-toastification";
import Errors from "@/helpers/Errors";

import TrgujInfoModal from "@/components/modals/TrgujInfoModal";
import OrderErrorModal from "@/components/modals/OrderErrorModal";
import DetailsModal from "@/components/modals/DetailsModal";
import OrderItems from "@/views/order/OrderItems";
import CardForm from "@/views/order/partials/CardForm";

export default {
  name: 'Order',
  components: {
    OrderErrorModal,
    TrgujInfoModal,
    DetailsModal,
    OrderItems,
    CardForm,
  },
  data() {
    return {
      errors: new Errors(),
      fetchingOrder: false,
      trgujInfoModal: {
        open: false,
        tab: null
      },
      detailsModalOpen: false,
    }
  },
  mounted() {
    this.fetchingOrder = true;

    this[FETCH_ORDER](this.$route.params.order)
        .catch((error) => {
          if (error.response) {
            this.errors.setErrors(error.response.data.errors);

            const orderErrors = error.response.data.errors.order;

            if (error.response.status === 423 && orderErrors) {
              this.toast.error(orderErrors[0]);
            }
          }
        })
        .finally(() => this.fetchingOrder = false);

    // console.log('public key: ' + process.env.VUE_APP_ALL_SECURE_PUBLIC_KEY)
  },
  computed: {
    ...mapGetters("order", ["products", "featuredProduct", "total"]),

    orderHasError() {
      return Boolean(this.errors.get('order'));
    },
    rightSideBgColor() {
      switch (this.$route.params.status) {
        case "success":
          return "before:bg-green-500"
        case "cancel":
          return "before:bg-amber-500";
        case "error":
          return "before:bg-red-500";
        default:
          return "before:bg-white"
      }
    },
    orderHasStatus() {
      return this.$route.params.status;
    }
  },
  methods: {
    ...mapActions("order", [FETCH_ORDER]),
    productsQtyLabel,
    priceInEur,
    handleDetailsModalOpen() {
      if (this.detailsModalOpen) {
        this.$refs.detailsModal.$refs.appModal.close();
      } else {
        this.detailsModalOpen = true;
      }
    },
    onTrgujInfoModalOpen(tab) {
      this.trgujInfoModal = {
        open: true,
        tab: tab
      };
    },
    onTrgujInfoModalClose() {
      this.trgujInfoModal = {
        open: false,
        tab: null
      };
    }
  },
  setup() {
    const toast = useToast();

    return {toast}
  },
}
</script>

<style scoped>
</style>
